import { Link } from 'react-router-dom';
import SafeImage from '../../../components/SafeImage';
import {
  JOURNEY_PUBLICATION_PREVIEW,
  JOURNEY_PUBLICATION_UNAVAILABLE_COPY,
  journeyPublicationCardView,
} from '../journeyPublicationCardModel';

/**
 * 公開行程分享卡片：只呈現讀取時 resolve 回傳的安全欄位；其餘狀態一律 fail closed。
 */
export default function JourneyPublicationCardMessage({ publicationId, resolution, note, onRetry }) {
  const view = journeyPublicationCardView(publicationId, resolution);

  if (view.state === 'loading') {
    return (
      <article className="travel-msg-card travel-msg-journey travel-msg-journey--pending" aria-busy="true" data-testid="journey-publication-card">
        <p role="status">行程載入中…</p>
      </article>
    );
  }

  if (view.state !== 'available') {
    return (
      <article className="travel-msg-card travel-msg-journey travel-msg-journey--unavailable" data-testid="journey-publication-card">
        <p className="travel-msg-card__status">{JOURNEY_PUBLICATION_UNAVAILABLE_COPY}</p>
        {view.state === 'failed' && onRetry ? (
          <button type="button" className="travel-msg-journey__retry" onClick={onRetry}>重新載入</button>
        ) : null}
      </article>
    );
  }

  const caption = typeof note === 'string' && note.trim() && note.trim() !== JOURNEY_PUBLICATION_PREVIEW
    ? note.trim()
    : '';
  const facts = [view.destinationSummary, view.dayCount ? `${view.dayCount} 天` : ''].filter(Boolean);

  return (
    <article className="travel-msg-card travel-msg-journey" data-testid="journey-publication-card">
      {caption ? <p className="travel-msg-journey__note">{caption}</p> : null}
      <Link
        className="travel-msg-journey__link"
        to={view.href}
        aria-label={`開啟行程：${view.title}`}
      >
        {view.coverUrl ? (
          <SafeImage className="travel-msg-card__cover" src={view.coverUrl} alt="" fallback={null} />
        ) : null}
        <span className="travel-msg-card__kicker">公開行程</span>
        <span className="travel-msg-card__title">{view.title}</span>
        {facts.length ? <span className="travel-msg-journey__facts">{facts.join(' · ')}</span> : null}
        <span className="travel-msg-journey__cta" aria-hidden="true">查看行程</span>
      </Link>
    </article>
  );
}
